import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeStyle, SafeScript, SafeUrl, SafeResourceUrl } from '@angular/platform-browser';


@Pipe({
  name: 'safe'
})
export class SafePipe implements PipeTransform {

  constructor(
    private readonly _sanitizer: DomSanitizer
  ) { }


  transform(value: string, type: string): SafeHtml | SafeStyle | SafeScript | SafeUrl | SafeResourceUrl {

    const cases: { [key in string]?: any; } = {
      'html': this._sanitizer.bypassSecurityTrustHtml(value), //NOSONAR
      'style': this._sanitizer.bypassSecurityTrustStyle(value), //NOSONAR
      'script': this._sanitizer.bypassSecurityTrustScript(value), //NOSONAR
      'url': this._sanitizer.bypassSecurityTrustUrl(value), //NOSONAR
      'resourceUrl': this._sanitizer.bypassSecurityTrustResourceUrl(value) //NOSONAR
    }

    return cases[type] || this._sanitizer.bypassSecurityTrustHtml(value); //NOSONAR
  }

}
